const HsrFooter = props => {
    return (
        <div>
            <h1>Footer</h1>
        </div>
    );
};

export default HsrFooter;
